/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Fetus } from './Fetus';
import {
    FetusFromJSON,
    FetusFromJSONTyped,
    FetusToJSON,
} from './Fetus';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface FetusPagination
 */
export interface FetusPagination {
    /**
     * 
     * @type {Array<Fetus>}
     * @memberof FetusPagination
     */
    data?: Array<Fetus>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof FetusPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the FetusPagination interface.
 */
export function instanceOfFetusPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FetusPaginationFromJSON(json: any): FetusPagination {
    return FetusPaginationFromJSONTyped(json, false);
}

export function FetusPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetusPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FetusFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function FetusPaginationToJSON(value?: FetusPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FetusToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

